import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "@/lib/apiClient";
import { PropsWithChildren } from "react";

export function ApiProvider({ children }: PropsWithChildren) {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}
